import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = [
    'investorTypeRadio',
    'individualFields',
    'legalFields',
    'maritalStatusSelect',
    'spouseFieldsWrapper',
    'labelAddress',
  ];

  static values = {
    labelAddressIndividual: String,
    labelAddressLegal: String,
  };

  connect() {
    this.toggleTypeFields();
    this.toggleMaritalStatusFields();

    $(this.maritalStatusSelectTarget).on('change', () => {
      this.toggleMaritalStatusFields();
    });
  }

  toggleTypeFields() {
    const investorType = this.investorTypeRadioTargets.find(
      (radio) => radio.checked
    ).value;

    if (investorType === 'individual') {
      this.individualFieldsTarget.classList.remove('d-none');
      this.legalFieldsTarget.classList.add('d-none');
      this.enableFieldsForGroup(this.individualFieldsTarget);
      this.disableFieldsForGroup(this.legalFieldsTarget);
      this.labelAddressTarget.innerText = this.labelAddressIndividualValue;
    } else {
      this.individualFieldsTarget.classList.add('d-none');
      this.legalFieldsTarget.classList.remove('d-none');
      this.enableFieldsForGroup(this.legalFieldsTarget);
      this.disableFieldsForGroup(this.individualFieldsTarget);
      this.labelAddressTarget.innerText = this.labelAddressLegalValue;
    }
  }

  toggleMaritalStatusFields() {
    const maritalStatus = this.maritalStatusSelectTarget.value;

    if (maritalStatus === 'marital_property_regime') {
      this.spouseFieldsWrapperTarget.classList.remove('d-none');
      this.enableFieldsForGroup(this.spouseFieldsWrapperTarget);
    } else {
      this.spouseFieldsWrapperTarget.classList.add('d-none');
      this.disableFieldsForGroup(this.spouseFieldsWrapperTarget);
    }
  }

  disableFieldsForGroup(group) {
    group.querySelectorAll('input, select').forEach((input) => {
      input.disabled = true;
    });
  }

  enableFieldsForGroup(group) {
    group.querySelectorAll('input, select').forEach((input) => {
      input.disabled = false;
    });
  }
}
